<ds-promo-badge
  [iconSrc]="'/assets/icons/' + iconPath + '.svg'"
  iconAlt="seat"
  [label]="serviceClass"
/>
